export const DEAL_ANIMATION_MAX_MS = 30000;

